function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76.2462 64.8438H7.75388V81.7031H76.2462V64.8438Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2616 38.9064L42 37.0908L15.5077 58.3596H6.46156C5.09059 58.3596 3.77578 58.9061 2.80636 59.8789C1.83694 60.8518 1.29233 62.1713 1.29233 63.5471C1.29233 64.9229 1.83694 66.2423 2.80636 67.2152C3.77578 68.188 5.09059 68.7346 6.46156 68.7346H7.75387",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.2462 68.7346H77.5385C78.9094 68.7346 80.2243 68.1881 81.1937 67.2153C82.1631 66.2424 82.7077 64.923 82.7077 63.5471C82.7077 62.1713 82.1631 60.8519 81.1937 59.879C80.2243 58.9062 78.9094 58.3596 77.5385 58.3596H68.4923L47.88 41.8115",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.3705 42.5634C34.2248 41.1686 33.5989 39.417 33.6 37.6094",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3539 25.9375V29.8281C43.4103 29.8281 45.3825 30.6479 46.8367 32.1072C48.2908 33.5665 49.1077 35.5457 49.1077 37.6094C49.1077 39.6731 48.2908 41.6523 46.8367 43.1116C45.3825 44.5708 43.4103 45.3906 41.3539 45.3906",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3538 25.9375C46.3499 25.9375 50.4 21.8731 50.4 16.8594C50.4 11.8457 46.3499 7.78125 41.3538 7.78125C36.3578 7.78125 32.3077 11.8457 32.3077 16.8594C32.3077 21.8731 36.3578 25.9375 41.3538 25.9375Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.3077 0V16.8594",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4 0V16.8594",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
});

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.eacbac0c.svg";
export { ForwardRef as ReactComponent };